import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { formatCurrency } from "Helpers/Format";

import UseAuth from "Hooks/UseAuth";
import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import QuotaForm from "../QuotaForm";
import * as S from "./styles";

const UpdateProjectQuotas = ({ projectId, linkOptions }) => {
  const { parsedJWT } = UseAuth();
  const { api } = UseServices();
  const { loading } = UseGlobalLoading();

  const [quotas, setQuotas] = useState([]);
  const [selectedQuota, setSelectedQuota] = useState(null);

  /*
   * ⚠️ GUARDA DO `projectId` (24/09/2026). A sub-aba é renderizada no primeiro
   * render do detalhe, quando `selectedProject` ainda é `{}` — logo `projectId`
   * chega `undefined`. Sem a guarda, a busca saía com `project_id: undefined`, o
   * backend recusava ("ID do projeto não informado") e, com deps `[]`, NUNCA
   * havia segunda tentativa: a sessão ficava vazia para sempre.
   *
   * Pelo caminho normal ninguém via, porque a aba padrão é "Documentos" e o
   * projeto já carregou quando o admin clica aqui. Quem expõe é o DEEP LINK
   * `?tab=` — que é justamente o que o e-mail ao admin e a tela de pendências
   * usam.
   */
  useEffect(() => {
    if (projectId) return getProjectQuotas(projectId);

    // eslint-disable-next-line
  }, [projectId]);

  const getProjectQuotas = (project_id) => {
    api
      .post("/project-quotas/get-project-quotas-by-project-id", {
        project_id: project_id,
      })
      .then((response) => {
        const quotas = response.data?.project_quotas;

        setQuotas(quotas);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  const is_sponsor = parsedJWT?.user?.is_sponsor;

  return (
    <S.Wrapper>
      {selectedQuota ? (
        <QuotaForm
          projectId={projectId}
          selectedQuota={selectedQuota}
          setSelectedQuota={setSelectedQuota}
          getProjectQuotas={getProjectQuotas}
          linkOptions={linkOptions}
          isSponsor={is_sponsor}
        />
      ) : null}
      <Form>
        <S.Section>
          <span>Valor Aportado</span>
          <hr />
        </S.Section>

        <S.Buttons>
          <div />

          <Button
            type="button"
            text="Cadastrar Valor Aportado"
            disabled={loading}
            onClick={() => setSelectedQuota(true)}
          />
        </S.Buttons>

        {!quotas.length ? <span>Nenhum valor aportado cadastrado.</span> : null}

        {quotas.map((quota) => (
          <S.Quota key={quota.id}>
            <S.QuotaInfos>
              {/* Sem o campo Nome (D6 da parte 2): patrocinador + valor. Desde
                  a parte 4 o rótulo traz também a SELETIVA quando o vínculo tem
                  uma — é assim que o formulário passou a identificar o aporte. */}
              <S.Header>
                <h2>
                  {quota.project_sponsor
                    ? quota?.project_sponsor?.select_project?.sponsor?.name ||
                      quota?.project_sponsor?.sponsor?.full_name
                    : "Não Cadastrado"}
                  {quota?.project_sponsor?.select_project?.name
                    ? ` - ${quota.project_sponsor.select_project.name}`
                    : ""}{" "}
                  — {formatCurrency(quota.value)}
                </h2>
              </S.Header>
              {/* "Comprar Cota" saiu daqui em 03/09/2026 (achado F3): o botão
                  já havia saído da área comum em 29/08 (D20) e sobrevivia nesta
                  tela, que o patrocinador nem abre. A escrita do aporte é do
                  admin (D5). */}
              <S.Buttons>
                {!is_sponsor && (
                  <Button
                    type="button"
                    text="Editar"
                    disabled={loading}
                    onClick={() => setSelectedQuota(quota)}
                  />
                )}
              </S.Buttons>
            </S.QuotaInfos>
          </S.Quota>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default UpdateProjectQuotas;
